const Default = () => import(/* webpackChunkName: "index" */ './Default');
const Park = () => import(/* webpackChunkName: "index" */ './Park');
const Head = () => import(/* webpackChunkName: "index" */ './Head');
const Manager = () => import(/* webpackChunkName: "index" */ './Manager');
const Admin = () => import(/* webpackChunkName: "index" */ './Admin');
const HeadSubFund = () => import(/* webpackChunkName: "index" */ './HeadSubFund/Fund')

export default {
  routes: [
    {
      path: '/index/admin',
      name: 'index_admin',
      component: Admin
    }, {
      path: '/index/default',
      name: 'index_default',
      component: Default
    }, {
      path: '/index/head',
      name: 'index_head',
      component: Head
    }, {
      path: '/index/manager',
      name: 'index_manager',
      component: Manager
    }, {
      path: '/index/Park',
      name: 'index_park',
      component: Park
    }, {
      path: '/index/HeadSubFund/Fund',
      name: 'index_headSubFund_fund',
      component: HeadSubFund
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/index/router.js